export default {
      id: "social-small-facebook-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#social-small-facebook",
      toString: function () {
        return this.url;
      }
    }